import { render, staticRenderFns } from "./garantie.vue?vue&type=template&id=92ddd03a&scoped=true"
import script from "./garantie.vue?vue&type=script&lang=ts"
export * from "./garantie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ddd03a",
  null
  
)

export default component.exports